import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { FeroResponseBody } from "../common/index.js";

const c = initContract();

export const healthCheckContract = c.router({
  getHealth: {
    method: "GET",
    path: "/healthz",
    responses: {
      [200]: FeroResponseBody(z.literal("OK")),
    },
    summary: "Health Check Endpoint.",
  },
});
